export default {
  lang: { en: "English", ko: "한국어", jp: '日本語', es: "Spanish", pt: "Portuguese", zhHant: '繁體中文' },
  nav: {
    xwallet: "XWallet",
    overview: "Overview",
    howToUse: "How to use",
    userGuide: "User Guide",
    merchantGuide: "Merchant Guide",
    faq: "FAQ",
  },
  overview: {
    xwalletNew: {
      title: "XWallet by Pundi X",
      subTitle: "為眾人而生的區塊鏈錢包",
      down: "下載",
    },
    ubiquitous: {
      title: "無縫連結線上與線下區塊鏈交易",
      subTitle:
        "The XWallet mobile app connects regular digital asset wallets with the Pundi X payment ecosystem. It allows users to easily make payments in physical stores via the XPOS. The XWallet can also be paired with the XPASS, making it a digital payment app that can be used anytime, anywhere.",
      list1: "透過XPOS®️立即購買及消費數位資產",
      list2: "輕鬆傳送及收受數位資產給你的親朋好友",
      list3: "在XWallet中體驗多種DApp服務"
    },
    integration: {
      title: "Seamless integration",
      subTitle:
        "You can easily manage your digital assets, check your current balance, or top-up in the XWallet. By default, each user will have a virtual XPASS card in the app. You can also pair your XWallet with your Pundi XPASS card to make payments directly from the app when needed. If you lose the XPASS card, you can transfer all your tokens from the XPASS card to the XWallet app or to another XPASS card.",
      wallet: {
        title: "Top Up Your XWallet from other wallets",
        list1: "Select the ‘Card’ icon and choose the virtual card.",
        list2: "Select the type of currency you want to top up.",
        list3: "Tap on the ‘Receive’ icon and choose ‘View address’.",
        list4: "Copy the top-up address or scan the QR code.",
        list5:
          "On your other wallet, choose the correct type of cryptocurrency and insert the XWallet top-up address to make the transfer.",
        note:
          "(Note: The speed of transferring tokens from other wallets to the XWallet app varies, depending on their relevant blockchain network conditions. To make instant payment transaction at any XPOS merchant, we recommend users top up their XWallet account from other wallets at least 6 hours before using the app.)",
      },
    },
    payments: {
      title: "Instant Payments Online or Offline",
      subTitle:
        "Transactions via an internet-connected XWallet or XPASS can be processed immediately, while offline transactions can be made by scanning the QR code, which will later be uploaded onto the blockchain. The XWallet, in short, keeps up with your busy lifestyle.",
    },
    security: {
      title: "安全及可靠",
      subTitle:
        "Each XWallet comes with a username and password protection feature. There is also no need for (private key) data backup because it is not a cold wallet. The app can also help users easily retrieve data stored on any phone, device, or XPASS linked to the app.",
      list1: "支援雙重認證",
      list2: "提供擁有私鑰的選項",
      list3: "支援生物辨識安全鎖"
    },
    token: {
      title: "A guide to staking NPXS / NPXSXEM for f(x) tokens",
      subtitle: "From March 20, 2019 to March 19, 2020",
      linkBtn: "Learn more",
      link: "https://medium.com/pundix/771b82266941",
    },
    convert: {
      title: "A guide to converting NPXS / NPXSXEM to f(x) tokens",
      subtitle: "From April 16 to July 14, 2019",
      linkBtn: "learn more",
      link:
        "https://medium.com/pundix/a-guide-to-converting-npxs-npxsxem-to-f-x-tokens-e1d9f3dcec77",
    },
    privateWallet: {
      title: "支援多項私鑰錢包",
      list1: "使用XWallet中的非託管選項來掌控您的數位資產",
      list2: "支援Binance區塊鏈錢包、三星區塊鏈錢包和MEW提供的Pundi X Savings等私鑰錢包",
      list3: "支援MEWConnect",
      subTitle: "觀看教學影片",
      tutorial1: "如何創建Binance區塊鏈錢包",
      tutorial2: "如何創建MEW提供的Pundi X Savings錢包（安卓版）",
      tutorial3: "如何在XWallet中還原MEW錢包（安卓版）"
    },
    dapps: {
      title: "DApps",
      desc: "使用XWallet中的DApps來管理，轉移或增長您的數字資產",
      remark: "現在就開始探索XWallet中的DApps"
    },
    telegramChat: {
      title: "支援Telegram",
      list1: "在Telegram中和你的親友聊天",
      list2: "即刻接收及傳送Crypto Gift給你的親友",
      tutorial1: "如何連接至Telegram帳號",
      tutorial2: "如何傳送Crypto Gift",
      tutorial3: "如何接收Crypto Gift"
    },
    manageAssets: {
      title: "輕鬆管理及增長您的數位資產",
      list1: "將您的XPASS與XWAllet配對，更好管理您的數位資產",
      list2: "在不同的XPASS中無縫轉移您的數位資產",
      list3: "XWallet用戶之間即時發送和接收數位資產，無需手續費",
      list4: "透過XWallet中的不同DApp和功能來增加您的數位資產",
      subTitle: '觀看教學影片',
      tutorial1: "如何在XWallet中轉移您的數位資產"
    }
  },
  howToUse: {
    title: "How to use",
    subTitle: "XWallet by Pundi X",
    sect1: {
      title: "How to top up your XWallet",
      htuArr1: {
        title: "Transferring your digital assets to the XWallet",
        li1: '1. Tap on the "Card" and select the virtual card.',
        li2: "2. Select the type of currency you want to top up.",
        li3: "3. Tap the “Receive” icon and select “View address”.",
        li4: "4. Copy the top-up address or scan the QR code.",
        li5:
          "5. On your other wallet, choose the correct type of cryptocurrency and insert the XWallet top-up address to make the transfer.",
      },
      htuArr2: {
        title: "Transferring tokens from your XPASS card to the XWallet",
        li1: "1. Add your XPASS card to the XWallet app.",
        li2:
          "2. Tap on your XPASS card that you want to transfer the tokens from.",
        li3:
          "3. Choose the type of currency you want to transfer to the XWallet.",
        li4:
          "4. Tap the ‘...’ icon on the upper right hand side and choose ‘Internal transfer’.",
        li5: "5. Select the XPASS card you want to transfer the tokens from.",
        li6: "6. Enter the amount of tokens and click the ‘confirm’ button.",
      },
    },
    sect2: {
      title: "How to transfer tokens from your XWallet to an external address",
      li1: "1. Choose the card you want to transfer the tokens from.",
      li2: "2. Select the type of currency you want to transfer.",
      li3:
        "3. Tap onthe ‘Transfer’ icon and input the receiver address - please double-check as transactions cannot be reversed due to the immutability of the blockchain.",
      li4: "4. Tap ‘Next’ to complete the transaction.",
    },
  },
  userGuide: {
    title: "XWallet User Guide",
    subTitle: "XWallet by Pundi X",
    sect1: {
      title: "1. What is an XWallet Virtual Card?",
      desc:
        "Each user of XWallet has an original Virtual Card account that is not tied to any physical card, as a personal balance account of the XWallet. If you have XPASS physical card, you can add it into XWallet by tapping the icon “+” on the top left of this page.",
      imgAlt: "Pundi X Virtual Card Account",
    },
    sect2: {
      title: "2. How to pay coins to merchant’s XWallet account:",
      li1: "Click “Scan” on the user homepage",
      li2: "Scan the Collection QR code belonging to the merchant",
      li3: "Enter the corresponding USDT amount (1 USDT = 1 USD)",
      li4: "Choose a card and the correct coin which has sufficient balance",
      imgAlt1: "Paying to merchant",
      imgAlt2: "Payment successful",
    },
    sect3: {
      title: "3. How to pay coins to merchant’s XPOS account:",
      li1: 'Click "Pay" on the user homepage',
      li2:
        "Show the user’s Payment QR code to the merchant so that he/she can scan the code to complete the transaction",
      li3:
        "Merchant will set the collection method according to the cryptocurrency you choose on your Payment code page",
      li4:
        "If the balance is insufficient, you will need to pay in other type of coins.",
      imgAlt: "Show payment code",
    },
    sect4: {
      title: "4. How to apply for a refund from merchants?",
      li1:
        "Unhappy with your purchased merchandise and would want to seek a refund from the merchant? It is recommended that you contact the merchant to request for a refund as soon as possible. The refunding request will be up to the merchant’s refunding policy.",
      li2:
        "If a refund request is initiated within 30 minutes after the transaction, the merchant will be able to complete the refund request on the XWallet.",
      li3:
        "Please note that the current system only supports refunding within 30 minutes of the transaction. If a refund request is made after 30 minutes, please contact the merchant for a manual refund process as it cannot be made via XWallet.",
      imgAlt1: "Find refund transaction",
      imgAlt2: "Refund successful details",
    },
    sect5: {
      title: "5. How to use the XWallet “Collect” function?",
      li1:
        "Transfer of funds among XWallet accounts can be completed by tapping the “Collect” icon.",
      li2:
        "Tap “Collect” on the homepage and save the collection code, then other users can transfer crypto to you using this code.",
      li3:
        "Note: Transfer among XWallet accounts is completed instantly without transfer fee.",
      imgAlt1: "Personal collection page",
      imgAlt2: "Personal collection code",
    },
    sect6: {
      title:
        "6. How to transfer from an XWallet account to another wallet/exchange address?",
      li1: "Tap “Transfer” on the homepage",
      li2: "Choose a coin for payment",
      li3: "Enter an address of the payee and the transfer amount",
      li4: "Confirm the transfer",
      li5:
        "After transfer, wait for the confirmation on the blockchain network to ensure that the payment is through.",
      note:
        "Note: please do enter a valid address without any mistakes during transfer. Crypto cannot be retrieved once the transaction is done due to the immutability of blockchain transactions.",
      imgAlt: "Tranfer NPXS",
    },
    sect7: {
      title: "7. How to receive/deposit cryptocurrencies in XWallet?",
      li1: "Select the type of cryptocurrency you want to receive/deposit.",
      li2: "Tap “Receive” and choose “View address”.",
      li3: "Copy the receive address or scan the QR code.",
      imgAlt1: "NPXS account",
      imgAlt2: "NPXS receive address",
    },
    sect8: {
      title: "8. How to receive XWallet Extra tokens",
      desc:
        "XWallet will update tasks in the “Extra” page from time to time, so that users can be educated with Pundi X projects features, updates, and milestones, simply by completing tasks and get crypto tokens. For further information, please go to the “Extra” page and check out the guides about token tasks.",
      imgAlt: "Extra page",
    },
    sect9: {
      title: "9. How to withdraw the received tokens?",
      li1:
        "Tokens in BTC, ETH, NPXS and other crypto currencies can be withdrawn only if the tokens amount reaches the designated withdrawal limit",
      li2:
        "Withdrawal of tokens in BTC, ETH, NPXS or other cryptocurrencies will be automatically transferred to the Virtual Card account.",
      imgAlt: "NPXS Tokens Withdrawal",
    },
    sect10: {
      title: "10. How to use XWallet voucher?",
      desc:
        "XWallet distributes vouchers to users from time to time. You can check your received vouchers in “My Vouchers” under the Extra section; Vouchers can be used when paying XWallet merchants for discounts; only 1 voucher per order.",
      imgAlt1: "My Vouchers",
      imgAlt2: "Use Voucher",
    },
    sect11: {
      title: "11. How to change or retrieve the XWallet passwords?",
      li1: "Go to “Me” on the homepage",
      li2: "Then go to “Settings” - “Security”",
      li3: "Click “Change login password” or “Change payment password”",
      li4: "Passwords can also be retrieved if forgotten.",
      imgAlt1: "“Me” page",
      imgAlt2: "Account Security page",
    },
    sect12: {
      title: "12. XWallet support",
      email: "Email：xwallet@pundix.com",
      tg: "Telegram:",
    },
  },
  merchantGuide: {
    title: "XWallet Merchant Guide",
    subTitle: "XWallet by Pundi X",
    sect1: {
      title: "1. How to apply to be an XWallet Merchant?",
      p1: "The application procedure is available here:",
    },
    sect2: {
      title: "2. How to make collections as a Merchant?",
      p1:
        "Submit an XWallet Merchant application, and once the application gets approved, then your “Collect” page would be marked with “Pundi X verified merchant”;",
      p2:
        "You can open the XWallet app, then show the QR code on “Collect” page for customers to scan and pay;",
      p3:
        "You can also tap “Save” on “Collect” page to download your QR code as a picture, print it out, and place it by the checkstand for customers to scan and pay. This would be a more convenient way to collect payments.",
      p4:
        "Collected cryptocurrency assets would go directly to the XWallet Merchant’s Virtual Card account.",
      imgAlt1: "Merchant Collection page",
      imgAlt2: "Collection code picture",
    },
    sect3: {
      title: "3. How to set the orders to be settled in USDT?",
      p1: "What are the benefits of using USDT for settlement？",
      p2:
        "Turning off USDT settlement would mean that the XWallet merchant can only collect cryptocurrencies like BTC, ETH, NPXS, etc. The merchant thus becomes prone to the price volatility and fluctuations of cryptocurrencies. USDT settlement can help XWallet Merchants convert all the collected cryptocurrency assets into USDT at real-time exchange rate. USDT is a stablecoin (1 USDT = 1 USD) that is not influenced by drastic price swings.",
      p3: "How to turn on USDT settlement?",
      p4:
        "Tap the icon on the top right of XWallet homepage, find “Merchant settings” and turn on USDT settlement.",
      imgAlt1: "USDT settlement",
      imgAlt2: "USDT settlement on",
    },
    sect4: {
      title: "4. How to check the “Collection history”?",
      p1:
        "Go to “Collect” and find “Collection history”, you can see all the entries for today’s and previous transactions.",
      imgAlt: "Collection history",
    },
    sect5: {
      title: "5. How to issue a refund?",
      p1:
        "To issue a refund, go to “Collection history”, find the particular transaction that requires a cancellation, and then tap on it to make a refund.",
      p2:
        "Note: refund can only be made within 30 minutes after a transaction has been completed. Refund requests after 30 minutes are not refundable from the system.",
      imgAlt1: "Find refund transaction",
      imgAlt2: "Refund successful details",
    },
    sect6: {
      title: "6. How to withdraw USDT as an XWallet Merchant?",
      p1: "Open the XWallet app and select “Card”",
      p2: "Go to USDT settings and tap “Transfer”",
      p3:
        "Enter the recipient’s address (withdraw address) and the transfer amount",
      p4: "Double-check and confirm the entered information",
      p5: "Then proceed with the transfer",
      p6:
        "Please wait for the final transaction outcome as all transactions need to be broadcasted and updated on the blockchain network.",
      imgAlt1: "USDT account",
      imgAlt2: "USDT withdraw",
    },
  },
  faq: {
    title: "FAQ",
    subTitle: "XWallet by Pundi X",
    faqArr: {
      "0": {
        title: "1. What is an XWallet?",
        text: {
          "0":
            "The XWallet is a mobile digital asset wallet application that supports the balance management of your XPASS cards, offline code-scanning payment, as well as mobile app payment.",
        },
      },
      "1": {
        title:
          "2. How do I get the XWallet app? What is the basic requirement for running XWallet?",
        text: {
          "0":
            "Download the XWallet app from Pundi X official website at https://www.pundix.com, or download from the Google Play Store. XWallet runs on Android 4.4 and above; iOS system 10.0 and above",
        },
      },
      "2": {
        title:
          "3. Can I use XWallet app to pay without linking to any XPASS cards?",
        text: { "0": "Yes, you can use it as a standalone payment app." },
      },
      "3": {
        title: "4. How can I top up the XWallet?",
        text: {
          "0":
            "To top up your XWallet balance, you can transfer funds from other digital asset wallet addresses to your XWallet.",
          "1":
            "If you have a XPASS card, you can also add your XPASS card to the XWallet app.",
        },
      },
      "4": {
        title: "5. How to top up the XPASS Card using XWallet?",
        text: {
          "0":
            "The balance from your XWallet can be transferred to the asset address linked to your XPASS card:",
          "1": "1. Select the type of currency you want to top up",
          "2": "2. Copy the top-up address or scan the top-up QR code",
          "3":
            "3. Use the other wallet (with the correct type of cryptocurrency) to make the transfer",
        },
      },
      "5": {
        title: "6. How do I accept coins from other wallets on XWallet?",
        text: {
          "0":
            "Select the type of currency supported by XWallet and use the transfer function of other wallets to top up the corresponding address of your XWallet.",
        },
      },
      "6": {
        title: "7. Does the XWallet share the same address as the XPASS card?",
        text: {
          "0":
            "No. Each XPASS card has its own unique address which is different from the XWallet address. Your XWallet will contain its own unique address.",
        },
      },
      "7": {
        title: "8. Which currencies are supported by the XWallet?",
        text: {
          "0":
            "The launch edition will be supported by four currencies: Bitcoin, Ethereum, BNB and NPXS. An update will soon follow which will greatly expand the range of supported currencies.",
        },
      },
      "8": {
        title: "9. How do I set the password for my XWallet?",
        text: {
          "0":
            "When registering your XWallet, you will be prompted to setup your login password and payment password. You can also change the password in the XWallet settings.",
        },
      },
      "9": {
        title: "10. What do I do if I have forgotten my XWallet password?",
        text: {
          "0":
            "You can retrieve your password in the XWallet settings or get assistance by contacting our customer service at XWallet [at] pundix.com.",
        },
      },
      "10": {
        title: "11. How can I back up my XWallet data?",
        text: {
          "0":
            "The XWallet is not a cold wallet, so there is no need for a backup.",
        },
      },
      "11": {
        title:
          "12. Can I add the XPASS card to the XWallet app on another phone / device?",
        text: {
          "0":
            "Once your XPASS card is linked to your XWallet app, you can retrieve the data of your XPASS card on any phone or device via the XWallet app.",
        },
      },
      "12": {
        title:
          "13. What should I do if the digital assets in my XWallet were stolen?",
        text: {
          "0":
            "Ensuring security in the XWallet app is of the utmost importance to us. If any digital assets were to go missing or stolen from your XWallet, please email xwallet [at] pundix.com immediately with your registered email. We will investigate and take action immediately to make sure your funds stay safe.",
        },
      },
      "13": {
        title:
          "14. Does XWallet support NPXS monthly unlocked token distribution?",
        text: { "0": "Yes it does." },
      },
      "14": {
        title:
          "15. Will I have a private key when setting up an account in XWallet app?",
        text: {
          "0":
            "No. Your email address and mobile number are required when setting up an XWallet app account.",
        },
      },
    },
    other:
      "Didn’t find the answers to your questions? You can find more XWallet FAQs here.",
  },
};
